interface ReviewModalsProps {
  showFlagModal: boolean;
  showNoteModal: boolean;
  showConfirmModal: boolean;
  flagReason: string;
  noteContent: string;
  processing: boolean;
  onFlagReasonChange: (value: string) => void;
  onNoteContentChange: (value: string) => void;
  onFlagSubmit: () => void;
  onNoteSubmit: () => void;
  onConfirmApprove: () => void;
  onCloseFlagModal: () => void;
  onCloseNoteModal: () => void;
  onCloseConfirmModal: () => void;
}

export function ReviewModals({
  showFlagModal,
  showNoteModal,
  showConfirmModal,
  flagReason,
  noteContent,
  processing,
  onFlagReasonChange,
  onNoteContentChange,
  onFlagSubmit,
  onNoteSubmit,
  onConfirmApprove,
  onCloseFlagModal,
  onCloseNoteModal,
  onCloseConfirmModal,
}: ReviewModalsProps) {
  return (
    <>
      {/* Flag Modal */}
      {showFlagModal && (
        <div className="modal-overlay" onClick={onCloseFlagModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>Flag Form Issue</h2>
            <textarea
              value={flagReason}
              onChange={(e) => onFlagReasonChange(e.target.value)}
              placeholder="Describe the issue..."
              rows={4}
            />
            <div className="modal-actions">
              <button onClick={onFlagSubmit} disabled={processing}>
                Submit
              </button>
              <button onClick={onCloseFlagModal}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Note Modal */}
      {showNoteModal && (
        <div className="modal-overlay" onClick={onCloseNoteModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>Add Note</h2>
            <textarea
              value={noteContent}
              onChange={(e) => onNoteContentChange(e.target.value)}
              placeholder="Enter your note..."
              rows={4}
            />
            <div className="modal-actions">
              <button onClick={onNoteSubmit} disabled={processing}>
                Add Note
              </button>
              <button onClick={onCloseNoteModal}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Confirm Approve Modal */}
      {showConfirmModal && (
        <div className="modal-overlay" onClick={onCloseConfirmModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>Confirm Approval</h2>
            <p style={{ marginBottom: "1.5rem" }}>
              Are you sure you want to approve this form? This action cannot be
              undone.
            </p>
            <div className="modal-actions">
              <button
                onClick={onConfirmApprove}
                disabled={processing}
                className="approve-button"
                style={{
                  backgroundColor: "#10b981",
                  color: "white",
                  fontWeight: "600",
                }}
              >
                ✓ Approve
              </button>
              <button onClick={onCloseConfirmModal}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
